module.exports = __webpack_public_path__ + "img/cave168.a4eb33ba.jpg";